import React from 'react'
// import emoji from '../react-easy-emoji'
// import {CloudinaryContext, Image, Transformation} from 'cloudinary-react'
import PropTypes from 'prop-types'
import CartAddToCartButton from './CartAddToCartSimpleButton'
import MagGlass from './MagGlassIcon'
import makeCloudinaryUrlForPhoto from './makeCloudinaryUrlForPhoto'
import {Link} from 'react-router-dom'
import IconAddToBagSVG from './IconAddToBagSVG'
import {get} from 'lodash'
import {isDateGateAvailable, isSoldOut} from './limitedProductTags'


import './MenuCategoryListView.scss'
import './MenuCategoryListViewDarkModeOveride.scss'
import { is } from 'core-js/core/object'
let MAX_ITEMS = 50

class MenuCategoryListView extends React.Component {

  state = {
    showAll: true
  }
  showRestOfCategory= () => {
    this.setState({ showAll: true })
  }
  render() {

    let className="photos grid"
    let isGallery = false
    let items = this.props.items
    let disableOrder = this.props.disableOrder
    let noPhoto = this.props.noPhoto
    let altStyleA = this.props.altStyleA
    const noOrder = this.props.noOrder
    const settings = this.props.settings
    const compactMode = this.props.compactMode
    const limitedStock = this.props.limitedStock || {}

    

    let tagsCss = this.props.tags ? (' ' + this.props.tags) : ''
    let compactCss = compactMode ? ' compact-mode' : ''
    let itemsToDisplay = this.state.showAll ? items : items.slice(0,MAX_ITEMS)
    return (
      <div className={"menu-category-list-view" + (altStyleA ? " alt-style-a" : "") + compactCss}>

        {/* List/Grid of Items */}
        <div className={className + tagsCss}>
          {itemsToDisplay.map(
            i => <MenuItem isGallery={isGallery}
              settings={settings}
              disableOrder={disableOrder}
              noOrder={noOrder}
              altStyleA={altStyleA}
              compactMode={compactMode}
              key={i.id} {...i}
              soldCount={limitedStock[i.id]}
              noPhoto={noPhoto}
              openPhotoSwipeGallery={this.props.openPhotoSwipeGallery}
              width={compactMode ? 80 : this.props.width}></MenuItem>)}
        </div>



        </div>
    );
  }
}

export default MenuCategoryListView

class MenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // console.log(name)
    let {altStyleA, noOrder, noPhoto, id, name, photo, width='600', description, mandatory, price, modgroups, originalPrice, modifiers, tags, settings, compactMode, soldCount, customPath, promoBase } = this.props
    // a product can open its own page (e.g. a custom builder) instead of /products/:id
    const productPath = customPath || `/products/${id}`
    const menuQuickUpdates = get(settings, 'menu', {})
    let cashbackPercentageAsInteger = Number(get(settings, 'cashbackPercentageAsInteger', 0));
    if (isNaN(cashbackPercentageAsInteger)) cashbackPercentageAsInteger = 0;
    // console.log('menuQuickUpdates', menuQuickUpdates)

    let priceListEl = null
    const toNumber = (v) => (v === null || v === undefined || v === '' || !isFinite(Number(v))) ? null : Number(v)
    // a text price like "S 6.50 M 6.99 L 7.50" can't show a timed-promo discount,
    // so altStyleA lists the first modgroup's priced options in its place
    const hasTextPrice = !!price && toNumber(price) === null
    if ((!price || (altStyleA && hasTextPrice)) && modgroups && modgroups[0]) {
      // make price from modifiers
      const firstModifiers = modgroups[0].modifiers || [];
      const formatPrice = (n) => (n % 1 === 0) ? `$${n}` : `$${n.toFixed(2)}`
      // option prices before a timed promo (src/timedPromos.js), shown struck through
      const baseModifiers = (promoBase && promoBase.modgroups && promoBase.modgroups[0] && promoBase.modgroups[0].modifiers) || []

      if (altStyleA) {
        // vertical list of the priced options, capped with a "+N more options" line
        const numericOpts = firstModifiers
          .map((m, i) => {
            const base = baseModifiers[i] ? toNumber(baseModifiers[i].price) : null
            return { name: (m.name && (m.name.en || m.name)) || '', price: toNumber(m.price), originalPrice: base }
          })
          .filter((o) => o.price !== null)
          .map((o) => (o.originalPrice !== null && o.originalPrice > o.price) ? o : Object.assign(o, {originalPrice: null}));

        // cap the card at MAX_LISTED_OPTIONS lines and shorten long option names
        const MAX_LISTED_OPTIONS = 3
        const MAX_OPTION_NAME_LENGTH = 18
        const shortName = (n) => (n.length > MAX_OPTION_NAME_LENGTH) ? n.slice(0, MAX_OPTION_NAME_LENGTH - 1).trimEnd() + '…' : n
        const listedOpts = numericOpts.slice(0, MAX_LISTED_OPTIONS)
        const moreCount = numericOpts.length - listedOpts.length
        if (listedOpts.length > 0) {
          price = null
          priceListEl = (
            <ul className="modifier-price-list">
              {listedOpts.map((o, i) => (
                <li key={i}>
                  <span className="opt-name" title={o.name}>{shortName(o.name)}</span>
                  {o.originalPrice !== null && <s className="opt-price-original">{formatPrice(o.originalPrice)}</s>}
                  <span className={"opt-price" + (o.originalPrice !== null ? " opt-price--sale" : "")}>{formatPrice(o.price)}</span>
                </li>
              ))}
              {moreCount > 0 && <li className="opt-more">+{moreCount} more {moreCount === 1 ? 'option' : 'options'}</li>}
            </ul>
          );
        }
      } else {
        let options = firstModifiers.map((modifier) => {
          if (typeof modifier.price === 'number') {
            return `${modifier.name}: $${modifier.price}`;
          } else {
            return `${modifier.name}`;
          }
        });
        let priceText = options.length ? 'Options: ' + options.join(', ') : '';
        price = priceText;
      }
    }

    let cssExtras = ''
    let disableOrderText = '*not availalbe online'
    name = name || {}
    let chinese = name.zh
    let korean  = name.kr
    name = (name && name.en) || "untitled"
    let isHalal = name.toLowerCase().indexOf('halal') !== -1
    if ((tags || "").indexOf('halal') !== -1) {
      isHalal = true
    }
    description = description && description.en
    let cssItemTags = tags ? " " + tags : ""
    if (isHalal) {
      cssItemTags += " halal"
    }
    

    let cloudinaryURL
    if (photo) {
      cloudinaryURL = makeCloudinaryUrlForPhoto(photo, {width})
    }

    let dineInOnly = (name.indexOf('Dine-In Only') !== -1)
    let disableOrder = this.props.disableOrder || dineInOnly
    if (menuQuickUpdates[id] && menuQuickUpdates[id].outOfStock === 'OUT_OF_STOCK') {
      disableOrder = true
      disableOrderText = '*OUT OF STOCK'
    }

    // Day-of-week restriction: hide items named "[Day] Only" on other days
    const DOW_DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    const todayDayName = DOW_DAYS[new Date().getDay()]
    const nameLower = name.toLowerCase()
    for (const day of DOW_DAYS) {
      if (nameLower.includes(`${day} only`) && day !== todayDayName) {
        disableOrder = true
        disableOrderText = 'not available today'
        break
      }
    }

    // Tag-based gating: date-gate-YYYY-MM-DD and lifetime-limit-N
    if (!isDateGateAvailable(tags)) {
      disableOrder = true
      disableOrderText = 'not available today'
    }
    if (isSoldOut(tags, soldCount)) {
      disableOrder = true
      disableOrderText = '*SOLD OUT'
    }

    let percentOff = null
    if (!originalPrice && typeof description === 'string') {
      const origMatch = description.match(/Originally\s+\$(\d+(?:\.\d{1,2})?)/)
      if (origMatch) {
        const parsedOriginal = parseFloat(origMatch[1])
        const numericPrice = parseFloat(price)
        if (!isNaN(parsedOriginal) && !isNaN(numericPrice) && parsedOriginal > numericPrice) {
          originalPrice = parsedOriginal
          percentOff = Math.round(((parsedOriginal - numericPrice) / parsedOriginal) * 100)
          description = description.replace(/Originally\s+\$\d+(?:\.\d{1,2})?/, '').trim()
        }
      }
    }

    if (noOrder) {
      disableOrder = true
      disableOrderText = ''
    }

    // Compact mode rendering
    if (compactMode) {
      if (photo) {
        cloudinaryURL = makeCloudinaryUrlForPhoto(photo, {width: 80, height: 80})
      }
      
      return (
        <section className={"menu-item compact" + cssItemTags}>
          <Link
            className="item-link"
            aria-label={`customize ${name} and add to cart`}
            to={disableOrder ? "#" : productPath}
          >
            {cloudinaryURL && !noPhoto && (
              <div className="compact-photo">
                <img
                  loading="lazy"
                  src={cloudinaryURL}
                  alt={"photo of " + name}
                />
              </div>
            )}
            <div className="compact-content">
              <span className="food-name">{name}</span>
              <span className="item-price">
                {(Number(price)) ? '$' : ''}{price}
              </span>
            </div>
            {(!disableOrder) && (
              <span className="compact-add">+</span>
            )}
          </Link>
        </section>
      )
    }
    
    if (altStyleA) {
      const menuItemPhotoStyle = photo ? " has-photo" : " no-photo"
      if (photo) {
        cloudinaryURL = makeCloudinaryUrlForPhoto(photo, {height: 300})
      }

      return(
        <section
            className={"menu-item" + menuItemPhotoStyle + cssItemTags}
            
            >
         {isHalal ? <span className="halal-icon">
            <img src="https://afag.imgix.net/crave-cafe-west-hills/halal-logo-1.png" alt="halal product" />
          </span>
          : null
          }
        <Link
            className="item-link"
            aria-label={`customize ${name} and add to cart`}
            title={`customize ${name} and add to cart`}
            to={disableOrder ? "#" : productPath}
            >
        <div className="content">
        <header>
       
          <span
            id={'p_' + id}
            className="food-name">{name}</span>
          
        </header>
    
          
          {originalPrice ? <div className="discount-price">${originalPrice} </div> : null}
          {priceListEl ? priceListEl : (
            <div className="item-price">
              {(Number(price)) ? '$' : ''}
              {price}
              {percentOff ? <span className="percent-off">{percentOff}% off</span> : null}
            </div>
          )}

          {disableOrder ? <div style={{fontStyle: "italic", fontSize: '0.8em'}} className="dine-in-only"> {disableOrderText} </div> : null}

          <p className="menu-item-description">
          {korean ? <span>{korean} ·</span> : ''} 
          {description}</p>

          {(!disableOrder) ? 
        <div className="add-to-cart-button-wrapper">
          <span className="plus-sign">
            +
          </span>
        </div> : null}
      </div>
      </Link>
        {cloudinaryURL && !noPhoto && <div
          className="photo-container-2"
          // onClick={this.props.openPhotoSwipeGallery.bind(this, id)}
          >
            <Link
            to={disableOrder ? "#" : productPath}
            >
              <img
                loading="lazy"
                decoding="async"
                fetchpriority="low"
                src={cloudinaryURL}
                alt={"photo of " + name}

              />
            </Link>
            {/* <MagGlass></MagGlass> */}
        </div>}


        

      </section>
      )
    }

    return (

        <section className={"menu-item" + cssExtras}>
          {cloudinaryURL && !noPhoto && <div
            className="photo-container"
            onClick={this.props.openPhotoSwipeGallery.bind(this, id)}>
              <img
                src={cloudinaryURL}
                alt={""}
              />
              {/* <MagGlass></MagGlass> */}
          </div>}
        <div className="content">
          <header>
            <span
              id={'p_' + id}
              className="food-name">{name}</span>
          </header>
          <p className="menu-item__description">
            {korean ? <span>{korean} ·</span> : ''} 
            {description}</p>
        </div>
        <div className="all-prices">
       {originalPrice ? <div className="discount-price">${originalPrice} </div> : null}
       {percentOff ? <span className="percent-off">{percentOff}% off</span> : null}
          {!disableOrder &&
            <Link
              className="product-link"
              aria-label={`customize ${name} and add to cart`}
              title={`customize ${name} and add to cart`}
              to={productPath}>
          
          
                <span className="plus">+</span> <span className="price">${price}</span>
          
              </Link>}
        </div>
          {disableOrder && <span className="price">${price} ({disableOrderText})</span>}
        </section>

    );
  }
}
